import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/layout/actions";
import {
  get_menu,
  add_menu,
  delete_menu,
  put_menu,
} from "../../store/menu/actions";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    };
  }

  async componentDidMount() {
    this.initMenu();
    await this.props.get_menu(this.state.isMobile);
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }
    }
  }

  hideSidebar = () => {
    if (this.state.isMobile) {
      this.props.changeSidebarType("default", this.state.isMobile);
    }
  };

  initMenu() {
    new MetisMenu("#side-menu");

    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {this.props.menu.menuitems &&
              this.props.menu.menuitems
                .sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
                .map((menuitm, index) => (
                  <li key={index}>
                    <Link
                      key={menuitm.id}
                      to={menuitm.link}
                      className="waves-effect"
                      onClick={()=>this.hideSidebar()}
                    >
                      <i className={"font-size-22 " + menuitm.icon}></i>
                      <span className="ml-3">{menuitm.title}</span>
                    </Link>
                  </li>
                ))}
            {this.props.menu.submenus &&
              this.props.menu.submenus
                .sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
                .map((submenu, index) => (
                  <li key={index}>
                    <Link to="/#" className="has-arrow waves-effect" >
                      <i className="ri-store-2-line"></i>
                      <span className="ml-1">{submenu.name}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false"  onClick={()=>this.hideSidebar()}>
                      {submenu.menuitems.map((mi, idx) => (
                        <li key={idx}>
                          <Link to={mi.link}>{mi.title}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}

            {/* {this.props.menu.map((menuob, index) => (
              <li key={index}>
                {menuob.menuitems && menuob.menuitems.length == 0 ? (
                  <Link
                    key={menuob.id}
                    to={menuob.link}
                    className="waves-effect"
                  >
                    <i className={menuob.icon + " ri-2x"}></i>
                    <span className="ml-3">{menuob.name}</span>
                  </Link>
                ) : (
                  <>
                    <Link to="/#" className="has-arrow waves-effect">
                      <i className="ri-store-2-line"></i>
                      <span className="ml-1">{menuob.name}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">
                      {menuob.menuitems.map((mi, idx) => (
                        <li>
                          <Link to="ecommerce-shops">{mi.code}</Link>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </li>
            ))} */}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { menu } = state.menu;
  return { menu };
};

export default withRouter(
  connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
    get_menu,
    add_menu,
    delete_menu,
    put_menu,
  })(SidebarContent)
);
